var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIconAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.982.621a1.001 1.001 0 00-.22-.325 1 1 0 00-1.42 0l-8.21 8.21-3.3-4.12a1 1 0 10-1.56 1.24l4 5a1 1 0 00.72.38h.06a1 1 0 00.71-.29l9-9a1.001 1.001 0 00.22-1.095z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIconAlt);
export default __webpack_public_path__ + "static/media/tick-icon-alt.c69e28b60dc4ff7ca1267fa2f70cbd87.svg";
export { ForwardRef as ReactComponent };